import apiBase from '~/api/base'
import store from '~/store'

const transformRequest = (jsonData = {}) => Object.entries(jsonData)
  .map((x) => `${encodeURIComponent(x[0])}=${encodeURIComponent(x[1])}`)
  .join('&')

async function getLeadsModel(type, id) {
  const eventId = store.getters['instancesState/getEventId']
  const language = store.getters['instancesState/getLanguage']

  // eslint-disable-next-line max-len
  const url = `${store.getters['instancesState/getApiBaseUrl']}/api/custominterfaces/lionleads/Lead/LeadsModel?eventid=${eventId}&language=${language}&type=${type}&id=${id}`
  const response = await apiBase.get(url)

  return response.data
}

async function getSymposiaLeadsModel(id) {
  const eventId = store.getters['instancesState/getEventId']
  const language = store.getters['instancesState/getLanguage']

  // eslint-disable-next-line max-len
  const url = `${store.getters['instancesState/getApiBaseUrl']}/api/custominterfaces/lionleads/Lead/SessionLeadsModel?eventid=${eventId}&language=${language}&id=${id}`
  const response = await apiBase.get(url)

  return response.data
}

async function addSymposiaLead(id, terms, additionalTerms, shareData) {
  const eventId = store.getters['instancesState/getEventId']

  const url = `${store.getters['instancesState/getApiBaseUrl']}/api/custominterfaces/lionleads/Lead/AddSessionLead`
  const data = {
    eventid: eventId,
    sessionid: id,
    pTermsAccepted: terms,
    pAdditionalTermsAccepted: additionalTerms,
    pShareData: shareData,
  }
  const response = await apiBase.post(url, data)
  return response.data
}

async function addCompanyLead(id, message, terms, additionalTerms, shareData) {
  const eventId = store.getters['instancesState/getEventId']

  const url = `${store.getters['instancesState/getApiBaseUrl']}/api/custominterfaces/lionleads/Lead/AddCompanyLead`
  const data = {
    eventid: eventId,
    pCompanyAccountId: id,
    note: message,
    pTermsAccepted: terms,
    pAdditionalTermsAccepted: additionalTerms,
    pShareData: shareData,
  }
  const response = await apiBase.post(url, data)
  return response.data
}

async function addCompanyQuestion(id, message, terms, additionalTerms) {
  const eventId = store.getters['instancesState/getEventId']

  const url = `${store.getters['instancesState/getApiBaseUrl']}/api/custominterfaces/lionleads/Lead/AddCompanyQuestion`
  const data = {
    eventid: eventId,
    pCompanyAccountId: id,
    note: message,
    pTermsAccepted: terms,
    pAdditionalTermsAccepted: additionalTerms,
  }
  const response = await apiBase.post(url, data)
  return response.data
}

async function addProductLead(companyId, terms, additionalTerms, shareData, productId) {
  const eventId = store.getters['instancesState/getEventId']

  const url = `${store.getters['instancesState/getApiBaseUrl']}/api/custominterfaces/lionleads/Lead/AddProductLead`
  const data = {
    eventid: eventId,
    exhibitionproductid: productId,
    pCompanyAccountId: companyId,
    pTermsAccepted: terms,
    pAdditionalTermsAccepted: additionalTerms,
    pShareData: shareData,
  }
  const response = await apiBase.post(url, data)
  return response.data
}

async function getIndustryTerm() {
  const eventId = store.getters['instancesState/getEventId']

  const url = `${store.getters['instancesState/getApiBaseUrl']}/api/Exhibition/IndustryTerms/${eventId}`
  const response = await apiBase.get(url)

  if (response.data) {
    return response.data
  }

  return null
}

async function confirmIndustryTerm() {
  const eventId = store.getters['instancesState/getEventId']

  const url = `${store.getters['instancesState/getApiBaseUrl']}/api/Exhibition/ConfirmIndustryTerms`
  const data = {
    eventid: eventId,
  }
  await apiBase.post(url, transformRequest(data))
}

export default {
  getLeadsModel,
  addCompanyLead,
  getIndustryTerm,
  confirmIndustryTerm,
  addProductLead,
  addCompanyQuestion,
  getSymposiaLeadsModel,
  addSymposiaLead,
}
